import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import type { KidMarker } from '../../../../../../../api/kids/types';
import type { KidDocumentForm } from '../../../types/KidPdfGeneratorV2.types';
import { getMarkersForPresetTag } from './getMarkersForPresetTag';

/** Syncs FIG:sri marker value and existing_markers onto the SRI chart element. */
export function usePresetSriInjection(
  index: number,
  markers: KidMarker[],
  sriValue: number | null,
) {
  const { setValue, getValues } = useFormContext<KidDocumentForm>();

  const sriMarkers = useMemo(
    () => getMarkersForPresetTag('sri_chart', markers),
    [markers],
  );

  useEffect(() => {
    if (sriValue == null) return;

    // Skip if the element was removed/shifted (see usePresetTableContent).
    if (getValues(`elements.${index}.tag` as const) !== 'sri_chart') return;

    setValue(`elements.${index}.content` as any, sriValue, {
      shouldDirty: false,
    });

    if (sriMarkers.length > 0) {
      setValue(`elements.${index}.existing_markers` as any, sriMarkers, {
        shouldDirty: false,
      });
    }
  }, [getValues, index, setValue, sriMarkers, sriValue]);

  return sriMarkers;
}
